import React from "react";
import "./TimeRegistrationDayCell.scss";

/**
 * Bloque de día (etiqueta abreviada + número) con fondo configurable.
 */
const TimeRegistrationDayCell = ({
	label,
	dayNumber,
	backgroundColor,
	className = "",
}) => {
	return (
		<div
			className={`time-registration-day-cell ${className}`.trim()}
			style={
				backgroundColor
					? { "--tr-day-bg": backgroundColor }
					: undefined
			}
		>
			<span className="time-registration-day-cell__label">{label}</span>
			<span className="time-registration-day-cell__number">{dayNumber}</span>
		</div>
	);
};

export default TimeRegistrationDayCell;
